import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "protected-image-state",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "protected-image-spinner",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-[#52526f] mt-2" }, "Carregando evidência...", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "protected-image-state",
  role: "alert"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-[#7f1d1d]" }, "Não foi possível carregar a evidência", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  class: "protected-image-obscured-overlay"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-[#52526f] font-medium" }, "Conteúdo protegido", -1)
const _hoisted_10 = [
  _hoisted_9
]

import { ref, watch, onBeforeUnmount, nextTick } from 'vue'
import Network from '@/Network'
import { useScreenCaptureGuard } from '@/hooks/useScreenCaptureGuard'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProtectedImage',
  props: {
    biometryId: {},
    blobUrl: {},
    rotation: { default: 0 },
    imgClass: {},
    containerClass: {}
  },
  emits: ["click"],
  setup(__props: any, { emit }) {

const props = __props;





const { isObscured, protectCanvas } = useScreenCaptureGuard()

const canvasRef = ref<HTMLCanvasElement | null>(null)
const ready = ref(false)
const loading = ref(false)
const error = ref(false)

let bitmap: ImageBitmap | null = null

function drawBitmap() {
  const canvas = canvasRef.value
  if (!bitmap || !canvas) return
  const swap = props.rotation % 180 !== 0
  canvas.width = swap ? bitmap.height : bitmap.width
  canvas.height = swap ? bitmap.width : bitmap.height
  const ctx = canvas.getContext('2d')
  if (!ctx) return
  ctx.clearRect(0, 0, canvas.width, canvas.height)
  ctx.save()
  ctx.translate(canvas.width / 2, canvas.height / 2)
  ctx.rotate((props.rotation * Math.PI) / 180)
  ctx.drawImage(bitmap, -bitmap.width / 2, -bitmap.height / 2)
  ctx.restore()
  protectCanvas(canvas)
}

function disposeBitmap() {
  if (bitmap) {
    bitmap.close()
    bitmap = null
  }
  ready.value = false
}

async function load(biometryId?: number, blobUrl?: string) {
  disposeBitmap()
  loading.value = true
  error.value = false
  try {
    let blob: Blob
    if (blobUrl) {
      const response = await fetch(blobUrl)
      if (!response.ok) throw new Error(`blob fetch failed: ${response.status}`)
      blob = await response.blob()
    } else if (biometryId) {
      blob = await Network.facialBiometry.getPhotoBlob(biometryId)
    } else {
      loading.value = false
      return
    }
    bitmap = await createImageBitmap(blob)
    ready.value = true
    await nextTick()
    drawBitmap()
  } catch {
    error.value = true
  } finally {
    loading.value = false
  }
}

watch(
  [() => props.biometryId, () => props.blobUrl],
  ([id, url]) => {
    if (url) load(undefined, url)
    else if (id) load(id)
    else disposeBitmap()
  },
  { immediate: true }
)

watch(
  () => props.rotation,
  () => {
    if (ready.value) drawBitmap()
  }
)

onBeforeUnmount(disposeBitmap)

return (_ctx: any,_cache: any) => {
  const _directive_protected_image = _resolveDirective("protected-image")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["protected-image-wrapper", _ctx.containerClass])
  }, [
    _withDirectives(_createElementVNode("canvas", {
      ref_key: "canvasRef",
      ref: canvasRef,
      class: _normalizeClass([_ctx.imgClass, { 'protected-image-obscured': _unref(isObscured) }]),
      role: "img",
      "aria-label": "Evidência de biometria facial"
    }, null, 2), [
      [_vShow, ready.value && !error.value],
      [_directive_protected_image]
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : _createCommentVNode("", true),
    (_unref(isObscured) && ready.value && !error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "protected-image-shield",
      onContextmenu: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
      onDragstart: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('click')))
    }, null, 32)
  ], 2))
}
}

})